// extracted by mini-css-extract-plugin
export default {"list":"MobileNavigationList_list__9Z2RN"};